import { KanbanObject } from '@nexelem/graphne-api';

const getTaskId = (task?: KanbanObject) => {
  if (task?.tpe === 'Task') {
    return task.id;
  }

  return task?.batchId;
};

const getTaskStatus = (task?: KanbanObject) => {
  if (task?.tpe === 'Task') {
    return task.status;
  }

  return task?.tasks?.[0]?.status;
};

export const KanbanObjectUtils = {
  getTaskId,
  getTaskStatus,
};
